import React, { useState, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import P5Canvas from "./P5Canvas/P5Canvas";
import ScrollDownAnim from "./ScrollDownAnim/ScrollDownAnim";
import "./Hero.scss";

const Hero = (props) => {
  const [canvasOpacity, setCanvasOpacity] = useState(0);

  useEffect(() => {
    setCanvasOpacity(0.8);
  }, []);

  const renderPortfolioContent = () => {
    return (
      <div className=" portfolio-content">
        <Row className="justify-content-center py-5">
          <Col md={8} sm={12}>
            <h2 className="home-page display-1 font-weight-bolder">
              {props.title}
            </h2>
            <h3 className="home-page display-4 font-weight-light">
              {props.subtitle}
            </h3>
            <h4 className=" home-page lead dont-weight-light">
              {props.content}
            </h4>
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <div className="Hero">
      <div
        className="header"
        style={{
          opacity: `${canvasOpacity}`,
          transition: `all 2s ease-in-out`,
        }}
      >
        {/* Here goes the Canvas */}
        <P5Canvas />
      </div>
      {renderPortfolioContent()}
      {props.home}
      {/* <ScrollDownAnim/> */}
    </div>
  );
};



export default Hero;
